//
//
//
//
//
//
//
//
//
//
//
//



export default {
    name: 'selectShopModal',
    props: {
        onSelected: Function,
        shopType: Number
    },
    data() {
        const vm = this;
        return {
            loading: false,
            shopColumns: [
                {
                    key: 'id',
                    title: 'Id',
                    width: 80,
                    align: 'center'
                },
                {
                    key: 'name',
                    title: '名称'
                },
                {
                    key: 'shopType',
                    title: '类型',
                    render(h, params) {
                        const row = params.row;
                        if (row.shopType == 0) {
                            return h('span', '积分商城');
                        } else {
                            // return '汽车商城';
                            return h('span', '线下实体店');
                        }
                    }
                },
                {
                    key: 'shopkeeperName',
                    title: '店主'
                },
                {
                    key: 'actions',
                    title: '操作',
                    width: 100,
                    align: 'center',
                    render(h, params) {
                        return h('Button', {
                            props: {
                                size: 'small',
                                type: 'primary'
                            },
                            on: {
                                click() {
                                    if (vm.onSelected !== undefined) {
                                        vm.onSelected(params.row);
                                    }
                                }
                            }
                        }, '选择');
                    }
                }
            ],
            shops: [],

            totalCount: 0,
            currentPage: 1
        };
    },
    methods: {
        getShops() {
            this.loading = true;
            const skip = (this.currentPage - 1) * 10;
            abp.ajax.post('/api/services/app/Shop/SearchShops', {
                shopType: this.shopType,
                maxResultCount: 10,
                skip: skip
            }).then(res => {
                this.shops = [];
                this.shops.push(...res.data.result.items);
            }).finally(() => {
                this.loading = false;
            });
        },
        pageChange() {
            this.getShops();
        }
    },
    created() {
        this.getShops();
    },
    computed: {},
    watch: {
        shopType() {
            this.getShops();
        }
    }
};
